import { NgModule } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { environment } from '../../../environments/environment';

@NgModule({
    imports: [
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFirestoreModule
    ],
    declarations: [],
    exports: [AngularFireAuthModule, AngularFirestoreModule]
})
export class MdSelectDataModule {}


// WEBPACK FOOTER //
// ./src/app/modules/datamodel/mdselect.module.ts